import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Tabs, Card, Button, Row, Col, Statistic, Divider, notification } from "antd";
import { PlusOutlined, LineChartOutlined, DollarOutlined, TagsOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useStore } from '../../../stores/root-store-context';
import ERPLayout from '../../../components/layout/ERPLayout';
import FinanceOverview from './FinanceOverview';
import CurrencyManagement from './CurrencyManagement';
import OperationTypeManagement from './OperationTypeManagement';
import TransactionManagement from './TransactionManagement';
const { TabPane } = Tabs;

const CompanyFinances = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { applicationStore } = useStore();
    const [activeTab, setActiveTab] = useState<string>("overview");
    const { tabKey } = useParams<{ tabKey: string }>();
    
    useEffect(() => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    }, [tabKey]);

    const handleTabChange = (key: string) => {
        setActiveTab(key);
        navigate(`/${applicationStore.company?.Tenant}/erp/finances/${key}`);
    };

    const breadcrumbItems = [
        { label: t("Home"), path: `/${applicationStore.company?.Tenant}` },
        { label: t("ERP"), path: `/${applicationStore.company?.Tenant}/erp` },
        { label: t("Finances"), path: `/${applicationStore.company?.Tenant}/erp/finances` }
    ];

    return (
        <ERPLayout breadcrumbTitle={t("CompanyFinances")} breadcrumbItems={breadcrumbItems}>
            <div style={{ width: "98%", maxWidth: 2400, margin: "20px auto 50px" }}>
                <Card bordered={false}>
                    <Tabs 
                        activeKey={activeTab} 
                        onChange={handleTabChange}
                        type="card"
                        size="large"
                        tabBarStyle={{ marginBottom: '24px' }}
                    >
                        <TabPane 
                            tab={
                                <span>
                                    <LineChartOutlined /> {t("Overview")}
                                </span>
                            } 
                            key="overview"
                        >
                            <FinanceOverview />
                        </TabPane>
                        
                        <TabPane 
                            tab={
                                <span>
                                    <DollarOutlined /> {t("Currencies")}
                                </span>
                            } 
                            key="currencies"
                        >
                            <CurrencyManagement />
                        </TabPane>
                        
                        <TabPane 
                            tab={
                                <span>
                                    <TagsOutlined /> {t("TransactionTypes")}
                                </span>
                            } 
                            key="operation-types"
                        >
                            <OperationTypeManagement />
                        </TabPane>
                        
                        <TabPane 
                            tab={
                                <span>
                                    <UnorderedListOutlined /> {t("Transactions")}
                                </span>
                            } 
                            key="transactions"
                        >
                            <TransactionManagement />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        </ERPLayout>
    );
});

export default CompanyFinances;